import type { MailboxInfo } from 'owa-client-types';
import { getAllAsyncItemEntries, type AsyncItemEntry } from 'owa-copilot-async-chat';
import { getTaskHubItemState, type TaskHubItemState } from '../utils/taskHubItemState';

/** A Tasks Hub item paired with the app-facing state it surfaces as. */
export interface SurfacedAsyncItem {
    entry: AsyncItemEntry;
    state: TaskHubItemState;
}

/**
 * The async items the Tasks Hub surfaces for an account: those whose status maps to a real state
 * (dropping None/Canceled) and are still unread. Single source of the hub's inclusion rule so the
 * section lists and the pane-selector badge count are always derived the same way.
 */
export function getSurfacedAsyncItems(mailboxInfo: MailboxInfo): SurfacedAsyncItem[] {
    const items: SurfacedAsyncItem[] = [];
    for (const entry of getAllAsyncItemEntries(mailboxInfo)) {
        const state = getTaskHubItemState(entry.status);
        if (state === undefined || !entry.isUnread) {
            continue;
        }
        items.push({ entry, state });
    }
    return items;
}
